import React from "react";

const LoomIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_535)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40 17.7759H28.3034L38.4331 11.9273L36.2087 8.07324L26.0787 13.9216L31.926 3.79262L28.0717 1.56665L22.2247 11.6956V0H17.7753V11.6969L11.926 1.56665L8.07298 3.79158L13.9213 13.9205L3.79132 8.07298L1.56665 11.9262L11.6964 17.7746H0V22.2244H11.6953L1.56665 28.0722L3.79132 31.9265L13.92 26.0792L8.07194 36.2082L11.9257 38.4328L17.774 28.3029V39.9998H22.2236V28.3039L28.0706 38.4328L31.9244 36.2082L26.0764 26.0782L36.2063 31.9265L38.431 28.0722L28.3023 22.2249H39.9977V17.7761L40 17.7759ZM19.9997 26.0512C16.6449 26.0512 13.9254 23.3321 13.9254 19.9769C13.9254 16.6221 16.6449 13.9026 19.9997 13.9026C23.3546 13.9026 26.0738 16.6221 26.0738 19.9769C26.0738 23.3321 23.3546 26.0515 19.9997 26.0515V26.0512Z",
  fill: "#625DF5"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_535"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LoomIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;